export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 – Trouvailles, Avis, QC et Guide d\'Achat',
  'home.metaDescription':
    'Explorez le USFans Spreadsheet avec des trouvailles de produits, des guides QC, des informations sur la livraison, des avis, des conseils de sécurité, des coupons et des ressources d\'achat pratiques pour 2026.',

  'home.navHome': 'Accueil',
  'home.navSpreadsheet': 'Spreadsheet',
  'home.navCategories': 'Catégories',
  'home.navGuides': 'Guides',
  'home.navShoppingGuide': 'Guide d\'achat',
  'home.navReviews': 'Avis',
  'home.navShipping': 'Livraison',
  'home.navSafety': 'Sécurité',
  'home.navVisit': 'Visiter le site principal',

  'home.heroBadge': 'Centre de ressources USFans Spreadsheet',
  'home.heroTitle': 'Trouvez de meilleurs produits avec le USFans Spreadsheet',
  'home.heroSubtitle':
    'Le USFans Spreadsheet facilite la recherche de produits en organisant des trouvailles utiles, des catégories, des ressources QC, des guides de livraison, des avis et des informations d\'achat dans un seul endroit consultable.',
  'home.heroSubtitle2':
    'Que vous soyez nouveau sur USFans ou que vous connaissiez déjà le processus, commencez ici pour rechercher des produits, comparer les options et comprendre le processus d\'achat avant de décider.',
  'home.heroTrust': 'Ressource informative indépendante • Mise à jour régulièrement • Adaptée aux débutants',
  'home.ctaSpreadsheet': 'usfans spreadsheet',
  'home.ctaBuyNow': 'acheter maintenant',
  'home.ctaGuide': 'Lire le guide débutant',

  'home.catTitle': 'Explorez les catégories du USFans Spreadsheet',
  'home.catSubtitle':
    'Parcourez des catégories organisées et accédez directement aux produits que vous recherchez sur le site principal.',
  'home.catPlaceholder': 'Sélectionnez une catégorie',
  'home.catBrowseAll': 'Voir toutes les catégories',
  'home.catShoes': 'Chaussures',
  'home.catHoodies': 'Sweats / Pulls',
  'home.catTshirts': 'T-shirts',
  'home.catJackets': 'Vestes',
  'home.catPants': 'Pantalons / Shorts',
  'home.catHeadwear': 'Couvre-chefs',
  'home.catSets': 'Ensembles',
  'home.catUnderwear': 'Sous-vêtements',
  'home.catJersey': 'Maillots',
  'home.catAccessories': 'Accessoires',
  'home.catBags': 'Sacs',
  'home.catBelts': 'Ceintures',
  'home.catPerfumes': 'Parfums',
  'home.catOther': 'Autres articles',

  'home.whatTitle': 'Qu\'est-ce que le USFans Spreadsheet ?',
  'home.whatP1':
    'Le USFans Spreadsheet est une ressource structurée pour découvrir et rechercher des liens de produits, des catégories et des informations d\'achat associées à USFans.',
  'home.whatP2':
    'Au lieu de chercher dans des publications dispersées, vous pouvez explorer des catégories organisées, des guides, des avis, des informations QC, des ressources de livraison et des questions fréquentes en un seul endroit.',
  'home.whatCta': 'Explorer le Spreadsheet',

  'home.whyTitle': 'Pourquoi utiliser un USFans Spreadsheet ?',
  'home.whySubtitle': 'Quelques raisons pour lesquelles le spreadsheet vous aide à acheter plus efficacement.',
  'home.why1Title': 'Recherchez plus vite',
  'home.why1Desc': 'Trouvez des produits et ressources pertinents sans parcourir des dizaines de pages sans rapport.',
  'home.why2Title': 'Comparez les options',
  'home.why2Desc': 'Utilisez des informations structurées et des tableaux comparatifs avant de décider.',
  'home.why3Title': 'Comprenez le QC',
  'home.why3Desc': 'Apprenez ce que signifient les photos QC et ce qu\'il faut vérifier avant l\'expédition.',
  'home.why4Title': 'Comprenez la livraison',
  'home.why4Desc': 'Apprenez comment le poids, la destination, l\'emballage et les méthodes de livraison affectent les coûts totaux.',

  'home.reviewTitle': 'Avis USFans',
  'home.reviewP':
    'Vous envisagez d\'utiliser USFans ? Lisez notre avis indépendant sur USFans couvrant le fonctionnement du processus, les avantages, les limites, le QC, l\'entrepôt, la livraison, la sécurité et les problèmes courants.',
  'home.review1': 'Comment fonctionne le processus',
  'home.review2': 'Avantages et limites',
  'home.review3': 'QC et entrepôt',
  'home.review4': 'Livraison',
  'home.review5': 'Sécurité et considérations utilisateur',
  'home.review6': 'Problèmes courants',
  'home.reviewCta': 'Lire l\'avis USFans',

  'home.shipTitle': 'Coût de livraison USFans',
  'home.shipP':
    'La livraison peut affecter considérablement le coût final d\'une commande. Apprenez comment le coût de livraison peut varier selon différents facteurs.',
  'home.ship1': 'Destination',
  'home.ship2': 'Poids et volume du colis',
  'home.ship3': 'Ligne de livraison et emballage',
  'home.ship4': 'Assurance et variations saisonnières',
  'home.shipNote': 'Les prix varient — vérifiez les tarifs actuels et estimez avant de payer.',
  'home.shipCta': 'Voir le guide des coûts de livraison',

  'home.couponTitle': 'Coupon et code promo USFans',
  'home.couponP':
    'Une ressource dédiée aux coupons USFans, codes promo, codes de réduction et coupons de livraison. Chaque page de coupon indique le statut, la date de vérification, l\'expiration, les restrictions et comment l\'appliquer.',
  'home.coupon1': 'Statut et date de vérification',
  'home.coupon2': 'Expiration et restrictions',
  'home.coupon3': 'Source',
  'home.coupon4': 'Comment l\'appliquer',
  'home.couponNote': 'Aucun code actif vérifié trouvé.',
  'home.couponCta': 'Voir les coupons actuels',

  'home.wareTitle': 'Entrepôt USFans',
  'home.wareP':
    'Comprenez ce que fait l\'entrepôt : photos QC, stockage, regroupement de colis, emballage, préparation d\'expédition, inspection et limites de stockage potentielles.',
  'home.ware1': 'Photos QC et inspection',
  'home.ware2': 'Stockage',
  'home.ware3': 'Regroupement de colis',
  'home.ware4': 'Emballage et préparation d\'expédition',
  'home.ware5': 'Limites de stockage potentielles',
  'home.wareCta': 'Lire le guide de l\'entrepôt',

  'home.legitTitle': 'USFans est-il fiable ?',
  'home.legitP':
    'Obtenez une réponse directe à l\'intention de recherche. Comprenez ce qu\'est USFans, comment fonctionne le processus d\'achat et quels risques et vérifications vous devez connaître avant de payer.',
  'home.legit1': 'Ce qu\'est USFans (et ce qu\'il n\'est pas)',
  'home.legit2': 'Comment fonctionne le processus d\'achat',
  'home.legit3': 'Quels risques comprendre',
  'home.legit4': 'Comment vérifier les informations',
  'home.legit5': 'Que vérifier avant de payer',
  'home.legitNote': 'Aucune affirmation non fondée — lisez les faits avant de décider.',
  'home.legitCta': 'Lire le guide de fiabilité',

  'home.compTitle': 'Comparaison du USFans Spreadsheet',
  'home.compHeader1': 'Ressource',
  'home.compHeader2': 'Objectif principal',
  'home.compHeader3': 'Idéal pour',
  'home.compHeader4': 'Infos QC',
  'home.compHeader5': 'Infos livraison',
  'home.compHeader6': 'Adapté aux débutants',
  'home.compRow1c1': 'Spreadsheet',
  'home.compRow1c2': 'Recherche de produits',
  'home.compRow1c3': 'Trouver des produits',
  'home.compRow1c4': 'Varie',
  'home.compRow1c5': 'Guide',
  'home.compRow1c6': 'Oui',
  'home.compRow2c1': 'Avis',
  'home.compRow2c2': 'Recherche sur la plateforme',
  'home.compRow2c3': 'Évaluation',
  'home.compRow2c4': 'Oui',
  'home.compRow2c5': 'Oui',
  'home.compRow2c6': 'Oui',
  'home.compRow3c1': 'Guide QC',
  'home.compRow3c2': 'Recherche de qualité',
  'home.compRow3c3': 'QC',
  'home.compRow3c4': 'Oui',
  'home.compRow3c5': 'Limitée',
  'home.compRow3c6': 'Oui',
  'home.compRow4c1': 'Guide de livraison',
  'home.compRow4c2': 'Recherche sur la livraison',
  'home.compRow4c3': 'Livraison',
  'home.compRow4c4': 'Non',
  'home.compRow4c5': 'Oui',
  'home.compRow4c6': 'Oui',

  'home.guidesTitle': 'Derniers guides USFans',
  'home.guidesSubtitle': 'Des guides frais et originaux pour rechercher et acheter en toute confiance.',
  'home.guidesRead': 'Lire l\'article',
  'home.guidesUpdated': 'Mis à jour',

  'home.faqTitle': 'Questions fréquentes',
  'home.faqQ1': 'Qu\'est-ce que le USFans Spreadsheet ?',
  'home.faqA1':
    'C\'est une ressource organisée qui rassemble des liens de produits, des catégories et des informations d\'achat dans un seul endroit consultable pour la recherche de produits.',
  'home.faqQ2': 'USFans est-il fiable ?',
  'home.faqA2':
    'USFans est un processus de recherche et d\'achat. Vérifiez toujours les liens, les informations du vendeur et comprenez les risques avant tout paiement.',
  'home.faqQ3': 'Combien coûte la livraison USFans ?',
  'home.faqA3':
    'La livraison varie selon la destination, le poids, le volume, la ligne, l\'emballage et la saison. Vérifiez les tarifs actuels avant de payer.',
  'home.faqQ4': 'Existe-t-il des codes promo USFans actifs ?',
  'home.faqA4':
    'Les codes changent souvent. Si aucun code actif vérifié n\'est disponible, prenez le prix normal comme référence.',
  'home.faqQ5': 'Que dois-je vérifier avant d\'acheter ?',
  'home.faqA5':
    'Consultez les photos QC, estimez la livraison, confirmez les informations du vendeur, vérifiez les politiques de retour et conservez les traces de votre commande.',

  'home.finalTitle': 'Prêt à explorer ?',
  'home.finalSubtitle':
    'Commencez avec le USFans Spreadsheet, puis utilisez nos guides pour rechercher des produits, comprendre le QC et comparer les options de livraison.',
  'home.finalCta': 'Explorer le USFans Spreadsheet',

  'home.footerDesc':
    'Une ressource informative indépendante sur le USFans Spreadsheet. Non affiliée ni approuvée par USFans sauf indication explicite.',
  'home.footerResources': 'Ressources',
  'home.footerSpreadsheet': 'USFans Spreadsheet',
  'home.footerGuides': 'Guides',
  'home.footerReviews': 'Avis',
  'home.footerShipping': 'Livraison',
  'home.footerCoupons': 'Coupons',
  'home.footerWarehouse': 'Entrepôt',
  'home.footerQC': 'QC',
  'home.footerSafety': 'Sécurité',
  'home.footerFaq': 'FAQ',
  'home.footerCompany': 'Entreprise',
  'home.footerAbout': 'À propos',
  'home.footerContact': 'Contact',
  'home.footerEditorial': 'Politique éditoriale',
  'home.footerPrivacy': 'Politique de confidentialité',
  'home.footerTerms': 'Conditions',
  'home.footerDisclaimer': 'Avertissement',
  'home.footerLanguages': 'Langues',
  'home.footerRights': 'Tous droits réservés.',
};